
    import Vue from "vue";

    const END_POINT = "/ruleCertification";

    const getRuleCertification = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllRuleCertifications = data => Vue.axios.get(END_POINT, {params: data});

    const createRuleCertification = ruleCertification => Vue.axios.post(END_POINT,  ruleCertification );

    const createAllRuleCertifications = RuleCertifications => Vue.axios.post(END_POINT + "/all",  RuleCertifications );

    const updateRuleCertification = ruleCertification => Vue.axios.put(END_POINT  + "/" + ruleCertification.id,  ruleCertification );

    const deleteRuleCertification = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getRuleCertification,
      getAllRuleCertifications,
      createRuleCertification,
      createAllRuleCertifications,
      updateRuleCertification,
      deleteRuleCertification
    };
    